// © Microsoft Corporation. All rights reserved.

/**
 * locationHref of page
 */
export const locationHref = (typeof (window) !== "undefined" ? window.location.href : "");

/**
 * Render-cache expiration time in ms
 * 86400000 = 24 hours in milliseconds
 */
export const defaultExpirationTimeMs = 86400000;

/**
 * Render-cache force expiration time in ms
 * 129600000 = 36 hours in milliseconds
 */
export const defaultForceExpirationTimeMs = 129600000;

/**
 * localStorage key prefix for render cache expiration timestamp
 * Stores the sliding window expiration
 */
export const expirationPrefix = "timestamp_";

/**
 * Force timestamp prefix for render cache values
 * Stores the absolute window expiration
 */
export const forceTimestampPrefix = "force_timestamp_";

/**
 * Jss map suffix for render cache values
 * Stores the jss class list map
 */
export const jssMapSuffix = "_jssMap";

/**
 * Prefix for render cache keys
 * Stores the collection of all render cache keys
 */
export const keysPrefix = "keys_";

/**
 * Prefix for render cache qsp to remove and normlize the url
 */
export const normalizedUrlConfigkey = "rcqsp";

/**
 * localStorage key prefix for render cache object
 * Stores the render cache snapshot
 */
export const storagePrefix = "lastKnown_";

/**
 * River Render Cache ClassName
 */
export const riverRcClassName = "river-rc";

/**
 * localStorage key for JSS Map object
 */
export const jssMapKey = `${storagePrefix}${locationHref}_jssmap`;

/**
 * localStorage key for render cache object
 */
export const renderCacheKey = `${storagePrefix}${locationHref}`;

/**
 * localStorage key for render cache expiration timestamp
 */
export const renderCacheExpirationKey = `${expirationPrefix}${locationHref}`;
